export default __webpack_public_path__ + "static/media/ProductSans-Regular.190f6362.woff";